import React, { Component, createRef } from "react";
import Header from "../../sections/Header/Header";

import Section1 from "../../sections/AO_Section1/AO_Section1";

import Footer from "../../sections/Footer/Footer";
import { ParallaxProvider } from "react-scroll-parallax";

import styled from "styled-components";

const CustomDiv = styled.div`
  min-height: 100vh;
  background: white;
  position: relative;
  z-index: 1;
  box-shadow: 0px 3px 6px #00000029;
`;
export default class Awards extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: null,
   
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    //console.log("Page: " + this.props.match.params.id)
  }
  render() {
    //let homeSectionShortcut = <HomeSectionShortcut section={sec} />;
    return (
      <div className="news-page">
        <Header onPage={"awards"}  />
        <CustomDiv>
          <ParallaxProvider>
            <React.Fragment>
              <div ref={this.section1}>
                <Section1/>
              </div>
            </React.Fragment>
          </ParallaxProvider>
        </CustomDiv>
        {/* <Footer /> */}
      </div>
    );
  }
}
